import { useAppState } from "../../overmind";
import NavBar from "./NavBar";
import Menu from "./Menu";
import Roulette from "../games/Roulette";

const Layout = ({ wallet, setWallet }) => {
  const { showMenu } = useAppState();
  console.log(wallet);

  return (
    <div>
      <NavBar wallet={wallet} setWallet={setWallet} />

      {showMenu && <Menu wallet={wallet} setWallet={setWallet} />}

      <main>
        {/* {children} */}
        <Roulette wallet={wallet} setWallet={setWallet} />
      </main>
    </div>
  );
};

export default Layout;
